module.exports = __webpack_public_path__ + "static/img/kb-card-app-main-img-01@m.2838356.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/kb-card/kb-card-app-main-img-01@m.png
// module id = xDXH
// module chunks = 0